import { pianoAnalytics } from 'piano-analytics-js';
import { TrackingProvider } from './components/TrackingProvider';
import { getTrackingProps } from './helpers';
import { mapRouteMatchToMatch } from './helpers/utils';
import { sendBulkCommerce } from './sendBulkCommerce';
import { sendClick } from './sendClick';
import { sendCommerce } from './sendCommerce';
import { sendInternalSearch } from './sendInternalSearch';
import { sendMVTesting } from './sendMVTesting';
import { sendPage } from './sendPage';
import { sendSelfPromotion } from './sendSelfPromotion';
import { setConfiguration } from './setConfiguration';
import { setProps } from './setProps';
function setPrivacyMode(privacyMode) {
  pianoAnalytics.privacy.setMode(privacyMode);
}
function getPrivacyMode() {
  return pianoAnalytics.privacy.getMode();
}
export { setConfiguration, getPrivacyMode, setPrivacyMode, setProps, sendPage, sendClick, sendCommerce, sendBulkCommerce, sendSelfPromotion, sendMVTesting, sendInternalSearch, getTrackingProps, mapRouteMatchToMatch, TrackingProvider };